/*!
 * KoliBri - The accessible HTML-Standard
 */
import { g as watchString, e as watchBoolean } from './common-D-vggmh2.js';
import { v as validateAutoComplete } from './auto-complete-C-QNfuIh.js';
import { a as validateHasCounter, v as validateMaxLengthBehavior, b as validateMaxLength } from './counter-dom-updater-osLR7-G0.js';
import { v as validatePlaceholder } from './placeholder-CmUUN-3U.js';
import { v as validateReadOnly } from './read-only-DyDY-E9H.js';
import { v as validateRequired } from './required-CGf-IRxL.js';
import { v as validateVariantClassName } from './variant-class-name-9qZ5egaq.js';
import { I as InputIconController } from './controller-icon-GPaN1UHM.js';

const validatePattern = (component, value, options = {}) => {
    watchString(component, '_pattern', value, options);
};

const validateVisibilityToggle = (component, value, hooks) => {
    watchBoolean(component, '_visibilityToggle', value, hooks);
};

class InputPasswordController extends InputIconController {
    constructor(component, name, host) {
        super(component, name, host);
        this.component = component;
    }
    validateAutoComplete(value) {
        validateAutoComplete(this.component, value);
    }
    validateHasCounter(value) {
        validateHasCounter(this.component, value);
    }
    validateMaxLengthBehavior(value) {
        validateMaxLengthBehavior(this.component, value);
    }
    validateMaxLength(value) {
        validateMaxLength(this.component, value);
    }
    validatePattern(value) {
        validatePattern(this.component, value);
    }
    validatePlaceholder(value) {
        validatePlaceholder(this.component, value);
    }
    validateReadOnly(value) {
        validateReadOnly(this.component, value);
    }
    validateRequired(value) {
        validateRequired(this.component, value);
    }
    validateValue(value) {
        watchString(this.component, '_value', value);
        this.setFormAssociatedValue(this.component.state._value);
    }
    validateVariant(value) {
        validateVariantClassName(this.component, value);
    }
    validateVisibilityToggle(value) {
        validateVisibilityToggle(this.component, value);
    }
    componentWillLoad() {
        super.componentWillLoad();
        this.validateAutoComplete(this.component._autoComplete);
        this.validateHasCounter(this.component._hasCounter);
        this.validateMaxLengthBehavior(this.component._maxLengthBehavior);
        this.validateMaxLength(this.component._maxLength);
        this.validatePattern(this.component._pattern);
        this.validatePlaceholder(this.component._placeholder);
        this.validateReadOnly(this.component._readOnly);
        this.validateRequired(this.component._required);
        this.validateValue(this.component._value);
        this.validateVariant(this.component._variant);
        this.validateVisibilityToggle(this.component._visibilityToggle);
    }
}

export { InputPasswordController as I };
//# sourceMappingURL=controller-QfZ_zY-h.js.map

//# sourceMappingURL=controller-QfZ_zY-h.js.map